export default {
    CREATE_CONTRACT_PARTNER: 'CREATE_CONTRACT_PARTNER',
    CREATE_CREDITOR: 'CREATE_CREDITOR',
    UPDATE_CONTRACT_PARTNER: 'UPDATE_CONTRACT_PARTNER',
    UPDATE_CREDITOR: 'UPDATE_CREDITOR',
    UPDATE_BUSINESS_RELATIONS: 'UPDATE_BUSINESS_RELATIONS',
};
